import { MouseEvent } from 'react'

import { IconClose } from '@avantstay/backoffice-vectors'

import { ICON_SIZE, PICKER_TEXT } from '../constants'
import { useClassNames } from '../utils/useClassNames'

interface CloseButtonProps {
  className: string
  onClick: (event: MouseEvent<HTMLSpanElement>) => void
}

export const CloseButton = ({ className, onClick }: CloseButtonProps) => {
  const { merge, withClassPrefix } = useClassNames('btn-close')

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <span
      role="button"
      tabIndex={-1}
      className={merge(className, withClassPrefix())}
      title={PICKER_TEXT.close}
      aria-label={PICKER_TEXT.close}
      onClick={onClick}
    >
      <IconClose width={ICON_SIZE} height={ICON_SIZE} />
    </span>
  )
}
